export default __webpack_public_path__ + "static/media/profile.046fa0c9.svg";